import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
// import { IRequirementMast } from "../../../models/RequirementMast";
// import { Fetch } from "../../../shared/Fetch";
import { useEffect, useState } from "react";
// import { ICityMastDropdown, IClientCompanyDropdown, ICountryMastDropdown, IStateMastDropdown, IUniversityDropdown, IVisaDropdown } from "../../../models/IDropdown";
import { useForm } from "react-hook-form";
// import { JVDropdownInput } from "../../../shared/JVDropdownInput";
// import { JVInput } from "../../../shared/JVInput";
// import { JVDropdown } from "../../../shared/JVDropdown";
// import { JVRadioBtn } from "../../../shared/JVRadioBtn";
// import { EmptySubmission } from "../EmptySubmission";
// import { CblType, NoticePeriod, Experience, TaxTerm, MatchingPer } from "../../../models/FDropdown";
// import { IConsultantMast } from "../../../models/ConsultantMast";
import { AutoComplete } from "primereact/autocomplete";
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from "primereact/inputtext";
// import { Req } from "../../../shared/Req";
// import { JVInputMask } from "../../../shared/JVInputMask";
import { Resumes } from "./Resumes";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { IRequirementMast } from "../../models/RequirementMast";
import { ICityMastDropdown, IClientCompanyDropdown, ICountryMastDropdown, IStateMastDropdown, IUniversityDropdown, IVisaDropdown } from "../../models/IDropdown";
import { IConsultantMast, TaxTerm } from "../../models/ConsultantMast";
import { Experience, NoticePeriod, MatchingPer, Submission_Type, Tax_Term } from "../../models/FDropdown";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVInput } from "../../shared/JVInput";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { Req } from "../../shared/Req";
import { EmptySubmission } from "./EmptySubmission";

interface Iprops {
    recruiter?: string,
    submission_id?: number,
    req_id?: number,
    cons_id?: number,
    vendor_Company_ID?: number,
    status?: number,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    hideDialogP: () => void
}

export const Submission = (props: Iprops) => {
    const [reject, setReject] = useState({ subrate: 0, isReject: false, reason: "" });
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<IRequirementMast>();
    const [additionInfo, setAdditionInfo] = useState("");

    const [resume, setResume] = useState({ open: false } as
        {
            vendor_Company_ID?: number,
            cons_id?: number,
            open: boolean
        });

    const hideDialog = () => {
        setResume({ open: false });
    };

    useEffect(() => {
        if (props.vendor_Company_ID && props.cons_id) setResume({
            vendor_Company_ID: props.vendor_Company_ID,
            cons_id: props.cons_id,
            open: true
        });
    }, [props.vendor_Company_ID, props.cons_id]);

    useEffect(() => {
        if (props.req_id) loadData();
    }, [props.req_id]);

    const loadData = async () => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.req_id}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setData(data);
        }
    }

    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [countries, setCountries] = useState<Array<ICountryMastDropdown>>();
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [universities, setUniversities] = useState<Array<IUniversityDropdown>>();
    const [university, setUniversity] = useState<IUniversityDropdown | undefined | string>(undefined);

    const { control, formState: { errors }, reset, setValue } = useForm<IConsultantMast>({
        defaultValues: EmptySubmission,
        shouldFocusError: false
    });

    useEffect(() => {
        if (university) {
            let un: string | undefined = undefined;
            if (typeof (university) === 'string') {
                un = university;
            } else {
                un = university?.university_Name;
            }
            setValue("university_Name", un);
        } else {
            setValue("university_Name", undefined);
        }
    }, [university]);

    useEffect(() => {
        if (props.submission_id) fillSub();
    }, [props.submission_id]);

    const loadCities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICityMastDropdown> = await response.json();
            setCities(data);
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadCountries = async (filter: string | null) => {
        const response = await Fetch("Dropdown/countries", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICountryMastDropdown> = await response.json();
            setCountries(data);
        }
    }
    const completeMethodCountries = (event: { query: string }) => {
        loadCountries(event.query);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }

    const loadUniversities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/universities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IUniversityDropdown> = await response.json();
            setUniversities(data);
        }
    }
    const completeMethodUniversities = (event: { query: string }) => {
        loadUniversities(event.query);
    }

    useEffect(() => {
        loadVisa();
    }, []);

    const fillSub = async () => {
        setLoading(true);
        setUniversity(undefined);

        const response = await Fetch("Consultant_Mast/submission", "GET", null, `submission_id=${props.submission_id}`, props.toast);
        if (response) {
            const data: IConsultantMast = await response.json();
            reset(data);
            setValue("identity", data.consultant_Email_ID);
            setValue("state", { state_ID: 1, state_Name: data.consultant_State });
            setValue("city", { city_ID: data.consultant_City, city_Name: data.city_Name });
            setValue("country", { country_ID: data.consultant_Country, country_Name: data.country_Name });
            setValue("company", { vendor_Company_ID: data.vendor_Company_ID, vendor_Company_Name: data.vendor_Company_Name });
            setValue("concent", data.concent);
            setValue("mathingProfilePer", data.mathingProfilePer);
            setValue("faceToFaceInterview", false);
            setValue("tax_Term", TaxTerm.C2C_With_Benefits);
            setUniversity({ university_ID: data.university_ID, university_Name: data.university_Name });
            if (data.addition_Info) setAdditionInfo(data.addition_Info);
            if (props.status && data.submittal_Rate) setReject({ subrate: data.submittal_Rate, isReject: reject.isReject, reason: reject.reason })
        }
        setLoading(false);
    }

    const saveToDB = async () => {
        setLoading(true);
        if (reject.isReject) {
            if (reject.reason.length < 1) {
                props.toast.current.show({ severity: 'error', detail: 'write the reason of rejection!', life: 3000 });
            }
            else {
                const response = await Fetch("Requirement_MAST/reqService", "POST", null, `req_id=${props.req_id}&cons_id=${props.cons_id}&buyrate=${control._formValues.hourly_Rate}&subrate=${0}&accepted=${!reject.isReject}&reason=${reject.reason}`, props.toast);
                if (response) {
                    props.toast.current.show({ severity: 'success', summary: 'Success', detail: 'Rejected Successfull!', life: 3000 });
                    props.hideDialogP();
                    props.setReload(!props.reload);
                    onHide();
                }
            }
        } else {
            if (reject.subrate < 1) {
                props.toast.current.show({ severity: 'error', detail: 'Fill the Submission Rate.', life: 3000 });
            } else if (reject.subrate < control._formValues.hourly_Rate) {
                props.toast.current.show({ severity: 'error', detail: 'Submission Rate should be greater than Buying Rate.', life: 3000 });
            } else if (!control._formValues.concent) {
                props.toast.current.show({ severity: 'error', detail: 'Please select Consent.', life: 3000 });
            } else if (!control._formValues.mathingProfilePer) {
                props.toast.current.show({ severity: 'error', detail: 'Please select Matching Profile Percentage.', life: 3000 });
            }
            else {
                const response = await Fetch("Requirement_MAST/reqService", "POST", null, `req_id=${props.req_id}&cons_id=${props.cons_id}&buyrate=${control._formValues.hourly_Rate}&subrate=${reject.subrate}
                &concent=${control._formValues.concent}&mathingProfilePer=${control._formValues.mathingProfilePer}&accepted=${!reject.isReject}`, props.toast);
                if (response) {
                    props.toast.current.show({ severity: 'success', summary: 'Success', detail: 'Accepted Successfull!', life: 3000 });
                    props.hideDialogP();
                    props.setReload(!props.reload);
                    onHide();
                }
            }
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptySubmission);
        setReject({ subrate: 0, isReject: false, reason: "" });
    }

    const dFooter = () => {
        return (<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button loading={loading} className="p-button-sm my-1" form="submissionForm" label={reject.isReject ? "OK" : "ACCEPT"} onClick={saveToDB} type="button"></Button>
            {!reject.isReject && <Button className="p-button-sm p-button-danger my-1" label="REJECT" onClick={() => setReject((r) => ({ ...r, isReject: true }))} type="button"></Button>}
        </div>);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Submit Consultant" footer={props.status ? "" : dFooter} className="p-fluid" draggable={false} onHide={onHide}>
            {data && <Req req={data} />}
            {!reject.isReject && <form id="submissionForm" className="p-fluid formgrid grid">

                <h3 style={{ margin: '10px 1vw 0px 1vw', width: '100%' }}>{props.recruiter}</h3>
                <div style={{ margin: '10px 1vw', width: '100%', fontWeight: 'bold' }}>Consultant Required Details:</div>

                <JVInput disabled placeholder="Consultant Name" column={3} control={control} name="consultant_Name" />
                <JVInput disabled placeholder="Enter Email" column={3} control={control} name="consultant_Email_ID" />
                <JVInputMask disabled required mask="(999) 999-9999" column={3} placeholder="Enter Phone" control={control} name="consultant_Home_No" error={errors.consultant_Home_No?.message} />
                <JVInput disabled placeholder="Enter Job Title" column={3} control={control} name="consultant_Job_Title" />

                <JVDropdown disabled column={3} control={control} name="visa_Status" options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="--Select Visa--" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodStates} control={control} name="state" options={states} optionLabel="state_Name" placeholder="Search State" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodCities} control={control} name="city" options={cities} optionLabel="city_Name" placeholder="Search City" />
                <JVDropdown disabled column={3} control={control} name="total_Experience" options={Experience} optionLabel="name" optionValue="name" placeholder="--Select Total Exp--" />

                <JVDropdown disabled column={3} control={control} name="availability" options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="--Select NoticePeriod--" />
                <JVRadioBtn inline label="F2F Interview" disabled data={[{ label: "Yes", value: true }, { label: "No", value: false }]} column={3} control={control} name="faceToFaceInterview" />
                <JVInput disabled={props.status ? true : false} placeholder="Buying Rate" type={"number"} column={3} control={control} name="hourly_Rate" />

                <div className="field col-12 md:col-4">
                    <InputText placeholder="Submission Rate" disabled={props.status ? true : false} value={reject.subrate} onChange={(e) => setReject({ isReject: reject.isReject, reason: reject.reason, subrate: Number(e.target.value ?? '0') })} type='number' name="sub_Rate" />
                </div>
                <JVRadioBtn inline label="Consent" disabled={!!props.status} data={[{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]} column={3} control={control} name="concent" />

                <JVDropdown disabled={!!props.status} column={3} control={control} name="mathingProfilePer" options={MatchingPer} optionLabel="name" optionValue="name" placeholder="--Select Matching Profile Percentage--" />
                <JVDropdown disabled column={3} control={control} name="tax_Term" options={Tax_Term} optionLabel="name" optionValue="id" placeholder="--Select TaxTerm--" />

                <div style={{ margin: '10px 1vw', width: '100%', fontWeight: 'bold' }}>Other Consultant Details:</div>

                {/* <JVDate disabled placeholder="Date Of Birth" column={3} control={control} name="dob" /> */}
                <JVInput disabled placeholder="Date Of Birth" column={3} control={control} name="dob" />
                <JVInput disabled placeholder="Enter Degree" column={3} control={control} name="degree" />
                <JVInput disabled placeholder="Employer Email" column={3} control={control} name="contact_Person_EmailID" />

                <JVInput disabled placeholder="Enter SSN" column={3} type={"number"} control={control} name="ssn" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodCountries} control={control} name="country" options={countries} optionLabel="country_Name" placeholder="Search Country" />
                <JVDropdownInput disabled column={3} completeMethod={completeMethodEC} control={control} name="company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Employer Company" />

                <JVDropdown disabled column={3} control={control} name="submissionType" options={Submission_Type} optionLabel="name" optionValue="id" placeholder="--Select JobType--" />
                {/* <JVInput column={3} control={control} name="universityName" error={errors.universityName?.message} placeholder="University"/> */}

                <div className="field col-12 md:col-4">
                    <div className="p-inputgroup">
                        <AutoComplete disabled suggestions={universities}
                            completeMethod={completeMethodUniversities} field='university_Name' value={university}
                            placeholder="Search/Type University" onChange={(e) => setUniversity(e.value)} />
                    </div>
                </div>

                <JVInput disabled placeholder="Enter Contact Name" column={3} control={control} name="contact_Person_Name" />

                <JVInput disabled placeholder="Enter Salary" type={"number"} column={3} control={control} name="annual_Salary" />
                <JVInput disabled placeholder="Enter Passing Year" column={3} control={control} name="passoutYear" />
                <JVInputMask disabled required mask="(999) 999-9999" column={3} placeholder="Employer Phone" control={control} name="phone_No" error={errors.phone_No?.message} />
                {additionInfo.length > 0 && <div className="col-12 md:col-12 md:col-6">
                    <CKEditor disabled editor={ClassicEditor} data={additionInfo} onChange={(event, editor) => { setAdditionInfo(editor.getData()); }} />
                </div>}
            </form>}
            {reject.isReject && <div className="p-fluid formgrid grid" style={{ margin: '8px', marginTop: '20px', marginBottom: '0px' }}>
                <label htmlFor="reason"> Reason : </label>
                <InputTextarea name="reason" placeholder="write the reason of rejection!" value={reject.reason} onChange={(e) => setReject((r) => ({ ...r, reason: e.target.value }))} rows={5} cols={30} maxLength={300} autoResize />
            </div>}
            <Resumes vendor_Company_ID={resume.vendor_Company_ID} cons_id={resume.cons_id} open={resume.open} hideDialog={hideDialog} toast={props.toast} />
        </Dialog>
    );
}
